<template>
  <div>
    <v-progress-linear
      v-if="loading && messages.length === 0"
      indeterminate
      color="primary"
      class="mb-4"
    />

    <v-card
      v-for="message in messages"
      :key="message.id"
      outlined
      class="mb-4"
    >
      <v-card-title class="text-subtitle-1 font-weight-medium">
        {{ formatModuleName(message.module) }}
      </v-card-title>

      <v-card-text>
        <v-textarea
          v-model="message.message"
          outlined
          dense
          auto-grow
          rows="2"
          hide-details="auto"
          :label="$t('setting.label.message') || 'Message'"
          class="mb-3"
        />

        <v-alert
          v-if="message.description"
          type="info"
          text
          dense
          border="left"
          class="mb-0"
        >
          <span v-html="message.description" />
        </v-alert>
      </v-card-text>

      <v-card-actions class="justify-end pt-0">
        <v-btn
          text
          small
          @click="update(message.id, true)"
          :loading="loading"
        >
          {{ $t('button.restore_default') || 'Restore Default' }}
        </v-btn>
        <v-btn
          color="primary"
          small
          :loading="loading"
          @click="update(message.id)"
        >
          {{ $t('button.save') || 'Save' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'DefaultMessages',
  data () {
    return {
      messages: [],
      loading: false
    }
  },
  methods: {
    formatModuleName (module) {
      if (!module) return ''
      return module
        .split('_')
        .map(w => w.charAt(0).toUpperCase() + w.slice(1))
        .join(' ')
    },
    update (id, useDefault = false) {
      this.loading = true
      const data = this.messages.find(m => m.id === id)
      data.use_default = useDefault
      this.$configService.setDefaultMessage(id, data)
        .then(data => {
          this.loading = false
          this.displayMessage(this.$t('status.success'))
        })
        .catch(this.globalErrHandle)
        .then(() => {
          this.loading = false
        })
    }
  },
  mounted () {
    this.$emit('parent-title', this.$t('setting.tabs.default_messages') || 'Default Messages')
    this.$emit('parent-description', this.$t('setting.desc.default_messages') || '')
    this.$configService.getDefaultMessages()
      .then(data => {
        this.messages = data
      })
  }
}
</script>
